import { gql } from '@apollo/client';

export const fetchListsWithParamsQuery = gql`
  fragment listsPageInfo on Lists {
    info {
      limit
      offset
      count
      page
    }
  }
  query fetchLists(
    $filterInfo: ListFilterInfoInput
    $pagination: Pagination
    $sort: Sort
    $search: String
  ) {
    lists(filterInfo: $filterInfo, pagination: $pagination, sort: $sort, search: $search) {
      ...listsPageInfo
      results {
        id
        name
        listType
        creatorUserId
        updatedAt
        createdAt
        description
        size
        hasBrandAffinityQuery
        updatedByUserId
      }
    }
  }
`;
